import useCasMutation, {
  IGenericMutationProps,
} from 'src/compass/shared/hooks/reactQuery/useCasMutation';

type uploadMutationProps = IGenericMutationProps & { url: string };

export default function useUploadMutation({ url, ...rest }: uploadMutationProps) {
  return useCasMutation({
    includesAttachment: true,
    method: 'post',
    url,
    ...rest,
  });
}
